export const findUserGroup = (ArrGroups, group_attend) => {
  if (Array.isArray(ArrGroups)) {
    const group = ArrGroups.find((user) => user.group_user === group_attend);
    if (group) {
      return Object.keys(group).length > 0;
    }
  } 

  return false;
}